var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_985",
    "data-name": "Group 985",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.436,
    height: 31.187,
    viewBox: "0 0 27.436 31.187",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.509,3.257H6.961V-1.074A.929.929,0,0,0,6.035-2H4.183a.929.929,0,0,0-.926.926V3.257H-1.074A.929.929,0,0,0-2,4.183V6.035a.929.929,0,0,0,.926.926H3.257v21.3a.929.929,0,0,0,.926.926H6.035a.929.929,0,0,0,.926-.926V6.961H24.509a.929.929,0,0,0,.926-.926V4.183A.929.929,0,0,0,24.509,3.257Z",
    transform: "translate(2 2)",
    fill: "#ff5c3c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.15 11.081)",
    fill: "none",
    stroke: "#fd5c3c",
    strokeWidth: 3.8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.285,
    height: 20.107,
    rx: 1.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.9,
    y: 1.9,
    width: 12.485,
    height: 16.307,
    rx: 0.4,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuLogo);
export default __webpack_public_path__ + "static/media/su_logo.9b30c61f7890f9d6c9e5c2a653c16e5e.svg";
export { ForwardRef as ReactComponent };